// material-ui
import { Box } from '@mui/material';

// ==============================|| LOGO ICON ||============================== //

const LogoIcon = () => (
  <Box
    aria-hidden
    sx={{
      width: 32,
      height: 32,
      borderRadius: 1,
      bgcolor: 'primary.main',
      color: 'common.white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: 18,
      lineHeight: 1
    }}
  >
    R
  </Box>
);

export default LogoIcon;
